export default () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.6716 8C22 8 22 8.01274 22 13.1174V17C22 24 22 24 16.6716 24H8C2 24 2 24 2 17V13.1175C2 8.0127 2 8.0127 7.24435 8.0127" stroke="#4FACFE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 17L12 3" stroke="#4FACFE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.3499 4.85L11.9999 1.5L8.6499 4.85" stroke="#4FACFE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)